import React from 'react';
import logo from '../../assets/logo-menu.png';
import './LoadingOverlay.css';

/**
 * Branded loading treatment: the drfah logo pulsing over a blurred, white-
 * washed veil of whatever sits underneath. By default it fills its nearest
 * positioned ancestor; `fullScreen` pins it to the viewport instead.
 *
 * `bootGate` marks the overlay as an "app not ready yet" state by adding the
 * `app-boot-spinner` class — scripts/prerender.js waits for that class to
 * DISAPPEAR before snapshotting a page. Only states that gate first paint
 * may set it (the boot intro in src/index.js, the route-chunk Suspense
 * fallback). Post-ready loading (refiltering a list, lazy media) must not.
 */
function LoadingOverlay({ fullScreen = false, bootGate = false, className = '' }) {
  const classes = [
    'loading-overlay',
    fullScreen ? 'loading-overlay--fixed' : '',
    bootGate ? 'app-boot-spinner' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status" aria-live="polite" aria-label="Loading">
      <img className="loading-overlay__logo" src={logo} alt="Drfah" />
    </div>
  );
}

export default LoadingOverlay;
